/**
 * Avignaa collection page — Lavanya-style filter drawer + quick-view drawer
 */
(function () {
  'use strict';

  const ROOT_SELECTOR = '.avignaa-collection-page';
  const CARD_SCOPE_SELECTOR = '.avignaa-collection-page, .avignaa-recently-viewed';
  const PRODUCT_DRAWER_CLASS = 'avignaa-product-quickview-open';
  const HIDDEN_FILTER_LABELS = ['availability', 'discount', 'fabric', 'neckline', 'sleeve type', 'sleeve-type'];

  const getShopRoot = () => {
    const root = window.Shopify?.routes?.root;
    return root ? (root.endsWith('/') ? root : `${root}/`) : '/';
  };

  const getCollectionRoot = () => document.querySelector(ROOT_SELECTOR);

  const closeFilterDrawer = () => {
    document.body.classList.remove('open-mobile-sidebar');
  };

  const decorateQuickDrawer = () => {
    const popup = document.getElementById('halo-quickshop-popup-option-3');
    const content = popup?.querySelector('.halo-popup-content');
    const quickshop = content?.querySelector('.quickshop');
    if (!content || !quickshop) return;

    popup.classList.add('avignaa-search-quickshop-drawer');
    quickshop.classList.add('avignaa-drawer-quickshop');

    if (!content.querySelector('.avignaa-drawer-heading')) {
      const heading = document.createElement('div');
      heading.className = 'avignaa-drawer-heading';
      heading.innerHTML = '<h2 class="avignaa-drawer-heading__title">Choose options</h2>';
      content.insertBefore(heading, content.firstChild);
    }

    const hideSource = (selector) => {
      quickshop.querySelectorAll(selector).forEach((node) => {
        node.classList.add('avignaa-drawer-source-hidden');
      });
    };

    hideSource('.halo-productView-left');
    hideSource('.on-desktop-hide');
    hideSource('.productView-title');
    hideSource('.productView-price');
    hideSource('.productView-badge');
    hideSource('form.installment');

    quickshop.querySelectorAll('.product-form__input, fieldset.product-form__input').forEach((input) => {
      const labelEl = input.querySelector('legend.form__label, legend, label.form__label, .form__label');
      const name = (labelEl?.textContent || '').trim().toLowerCase();
      const isSwatch = input.classList.contains('product-form__swatch')
        || !!input.querySelector('.pattern, .product-form__label .pattern');
      const isColorName = /\b(color|colour)\b/.test(name);

      if (isSwatch || isColorName) {
        input.classList.add('avignaa-drawer-source-hidden');
      }
    });

    const imgEl = quickshop.querySelector('.on-desktop-hide img[data-main-image], .on-desktop-hide img, .halo-productView-left img');
    const titleEl = quickshop.querySelector('.productView-title');
    const priceEl = quickshop.querySelector('.productView-price');
    const imgSrc = imgEl?.getAttribute('src') || imgEl?.dataset?.src || '';
    const title = titleEl?.textContent?.trim() || '';
    const priceHtml = priceEl?.innerHTML || '';
    const brandName = window.shop_name || 'AVIGNAA';

    let summary = content.querySelector('.avignaa-drawer-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'avignaa-drawer-summary';
      const heading = content.querySelector('.avignaa-drawer-heading');
      if (heading) {
        heading.insertAdjacentElement('afterend', summary);
      } else {
        content.insertBefore(summary, content.firstChild);
      }
    }

    summary.innerHTML = `
      <div class="avignaa-drawer-summary__media">
        ${imgSrc ? `<img src="${imgSrc}" alt="${title.replace(/"/g, '&quot;')}" loading="lazy" width="88" height="88">` : ''}
      </div>
      <div class="avignaa-drawer-summary__info">
        <p class="avignaa-drawer-summary__brand">${brandName}</p>
        <p class="avignaa-drawer-summary__title">${title}</p>
        <div class="avignaa-drawer-summary__price">${priceHtml}</div>
      </div>
    `;

    const productViewProduct = quickshop.querySelector('.productView-product');
    if (productViewProduct) {
      productViewProduct.classList.add('avignaa-drawer-product');
    }

    const cartQty = quickshop.querySelector('cart-update-quantity');
    const qtyInput = quickshop.querySelector('quantity-quick-shop-input.previewCartItem-qty, .previewCartItem-qty');
    if (cartQty && qtyInput && !cartQty.classList.contains('avignaa-drawer-qty-ready')) {
      cartQty.classList.add('avignaa-drawer-qty-ready');
      const qtyWrap = document.createElement('div');
      qtyWrap.className = 'avignaa-drawer-qty';
      const qtyLabel = qtyInput.querySelector('.quantity__label');

      if (qtyLabel) {
        qtyLabel.classList.remove('hiddenLabels');
        qtyLabel.textContent = 'Quantity:';
        qtyInput.removeChild(qtyLabel);
        qtyWrap.appendChild(qtyLabel);
      }

      qtyInput.parentNode.insertBefore(qtyWrap, qtyInput);
      qtyWrap.appendChild(qtyInput);
    }

    const seeDetailsBlock = quickshop.querySelector('.productView-see-details');
    const rightCol = quickshop.querySelector('.halo-productView-right');
    if (seeDetailsBlock && rightCol && !seeDetailsBlock.classList.contains('avignaa-drawer-footer')) {
      seeDetailsBlock.classList.add('avignaa-drawer-footer');
      rightCol.appendChild(seeDetailsBlock);
    }

    const seeDetailsLink = quickshop.querySelector('.productView-see-details a, .productView-see-details .button');
    if (seeDetailsLink) {
      seeDetailsLink.textContent = 'View details';
    }

    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  };

  const closeProductQuickDrawer = () => {
    document.body.classList.remove(PRODUCT_DRAWER_CLASS, 'quickshop-popup-show', 'quick-view-show');
    if (typeof jQuery !== 'undefined') {
      jQuery('body').removeClass(`quickshop-popup-show ${PRODUCT_DRAWER_CLASS}`);
    }
  };

  const openCollectionQuickDrawer = (handle) => {
    if (!handle) return;

    const quickShopPopup = document.getElementById('halo-quickshop-popup-option-3');
    if (!quickShopPopup) {
      window.location.href = `${getShopRoot()}products/${handle}`;
      return;
    }

    document.body.classList.add(PRODUCT_DRAWER_CLASS);
    document.body.classList.remove('quick-view-show', 'avignaa-search-drawer-open');

    if (typeof jQuery === 'undefined') return;

    const root = getShopRoot();
    const $body = jQuery('body');

    jQuery.ajax({
      type: 'get',
      url: `${root}products/${handle}?view=ajax_quick_shop`,
      beforeSend() {
        jQuery('#halo-quickshop-popup-option-3 .halo-popup-content').html('<div class="avignaa-drawer-loading">Loading...</div>');
      },
      success(data) {
        jQuery('#halo-quickshop-popup-option-3 .halo-popup-content').html(data);
        decorateQuickDrawer();
      },
      complete() {
        window.setTimeout(() => {
          $body.addClass(`quickshop-popup-show ${PRODUCT_DRAWER_CLASS}`);
          $body.removeClass('quick-view-show avignaa-search-drawer-open');

          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          if (window.show_multiple_currencies && typeof Currency !== 'undefined') {
            const activeCurrency = jQuery('#currencies .active').attr('data-currency');
            if (activeCurrency) {
              Currency.convertAll(window.shop_currency, activeCurrency, 'span.money', 'money_format');
            }
          }
        }, 120);
      },
      error(xhr) {
        console.error('Avignaa collection quick drawer failed:', xhr);
        document.body.classList.remove(PRODUCT_DRAWER_CLASS, 'quickshop-popup-show', 'avignaa-search-drawer-open');
      },
    });
  };

  const setupFilterDrawer = () => {
    const root = getCollectionRoot();
    if (!root) return;

    const sidebar = root.querySelector('#halo-sidebar');
    if (!sidebar) return;

    sidebar.classList.add('avignaa-collection-filter-drawer');

    const headerTitle = sidebar.querySelector('.halo-sidebar-header .title');
    if (headerTitle) {
      headerTitle.textContent = 'Filters';
    }

    const filterBtn = root.querySelector('[data-sidebar] .filter-text');
    if (filterBtn) {
      filterBtn.textContent = 'Filters';
    }

    const wrapper = sidebar.querySelector('.halo-sidebar-wrapper');
    if (wrapper && !wrapper.querySelector('.avignaa-filter-view-results')) {
      const footer = document.createElement('div');
      footer.className = 'avignaa-filter-view-results';
      footer.innerHTML = `<button type="button" class="avignaa-filter-view-results__btn">View results</button>`;
      wrapper.appendChild(footer);

      footer.querySelector('.avignaa-filter-view-results__btn').addEventListener('click', closeFilterDrawer);
    }

    setupFilterAccordion(sidebar);
    observeFilterUpdates(sidebar);
  };

  const getFilterBlockLabel = (block) =>
    (block.querySelector('.sidebarBlock-heading .facets__text')?.textContent || block.querySelector('.sidebarBlock-heading')?.textContent || '')
      .trim()
      .toLowerCase();

  const isHiddenFilterBlock = (block) => {
    const label = getFilterBlockLabel(block);
    return HIDDEN_FILTER_LABELS.some((hidden) => label === hidden || label.startsWith(`${hidden} `));
  };

  const hideExcludedFilters = (sidebar) => {
    sidebar.querySelectorAll('.sidebarBlock.js-filter').forEach((block) => {
      block.classList.toggle('avignaa-filter-hidden', isHiddenFilterBlock(block));
    });
  };

  const openFilterBlock = (block) => {
    const heading = block.querySelector('.sidebarBlock-headingWrapper .sidebarBlock-heading');
    const contentWrapper = block.querySelector('.sidebarBlock-contentWrapper');
    if (!heading || !contentWrapper) return;

    heading.classList.add('is-clicked');
    contentWrapper.style.display = 'block';
  };

  const reorderFilterBlocks = (sidebar) => {
    const wrapper = sidebar.querySelector('#CollectionFiltersForm .facets__wrapper');
    if (!wrapper) return;

    const priceBlock = wrapper.querySelector('.sibarbarBlock-filter-price, .sidebarBlock[data-type-price="true"]');
    const sizeBlock = wrapper.querySelector('.avignaa-size-filter');
    const colorBlock = wrapper.querySelector('.avignaa-color-filter');

    if (priceBlock && sizeBlock && priceBlock.nextElementSibling !== sizeBlock) {
      priceBlock.insertAdjacentElement('afterend', sizeBlock);
    }

    const anchorAfterPrice = sizeBlock || priceBlock;
    if (anchorAfterPrice && colorBlock && anchorAfterPrice.nextElementSibling !== colorBlock) {
      anchorAfterPrice.insertAdjacentElement('afterend', colorBlock);
    }
  };

  const setupFilterAccordion = (sidebar) => {
    hideExcludedFilters(sidebar);
    reorderFilterBlocks(sidebar);

    const visibleBlocks = [...sidebar.querySelectorAll('.sidebarBlock.js-filter')].filter(
      (block) => !block.classList.contains('avignaa-filter-hidden')
    );

    visibleBlocks.forEach((block) => {
      const heading = block.querySelector('.sidebarBlock-headingWrapper .sidebarBlock-heading');
      const contentWrapper = block.querySelector('.sidebarBlock-contentWrapper');
      if (!heading || !contentWrapper) return;

      if (!heading.dataset.avignaaAccordionBound) {
        heading.dataset.avignaaAccordionBound = 'true';
        heading.addEventListener('click', () => {
          window.setTimeout(() => {
            contentWrapper.style.display = heading.classList.contains('is-clicked') ? 'block' : 'none';
          }, 0);
        });
      }
    });

    const priceBlock = visibleBlocks.find((block) => /price/i.test(getFilterBlockLabel(block)));
    const defaultBlock = priceBlock || visibleBlocks[0];
    if (defaultBlock) {
      openFilterBlock(defaultBlock);
    }
  };

  const observeFilterUpdates = (sidebar) => {
    const filtersRoot = sidebar.querySelector('#main-collection-filters');
    if (!filtersRoot || filtersRoot.dataset.avignaaObserved) return;

    filtersRoot.dataset.avignaaObserved = 'true';
    const observer = new MutationObserver(() => {
      setupFilterAccordion(sidebar);
    });
    observer.observe(filtersRoot, { childList: true, subtree: true });
  };

  const setupToolbarCount = () => {
    const root = getCollectionRoot();
    if (!root) return;

    root.querySelectorAll('.toolbar .results-count .results').forEach((el) => {
      el.style.display = '';
    });
  };

  const enhanceProductCards = () => {
    document.querySelectorAll(CARD_SCOPE_SELECTOR).forEach((root) => {
      root.querySelectorAll('.card-quickview [data-open-quick-view-popup]').forEach((btn) => {
        if (btn.classList.contains('avignaa-collection-quickview-btn')) return;

        const label = btn.querySelector('.text')?.textContent?.trim() || btn.textContent?.trim() || 'Quick view';
        btn.className = 'avignaa-search-product-card__atc avignaa-search-product-card__qv avignaa-collection-quickview-btn';
        btn.textContent = label;
      });
    });
  };

  const observeProductGrid = (gridId) => {
    const grid = document.getElementById(gridId);
    if (!grid || grid.dataset.avignaaObserved) return;

    grid.dataset.avignaaObserved = 'true';
    const observer = new MutationObserver(() => {
      enhanceProductCards();
    });
    observer.observe(grid, { childList: true, subtree: true });
  };

  const observeRecommendationsBlocks = () => {
    document.querySelectorAll('[data-recommendations-block].avignaa-recently-viewed').forEach((block) => {
      if (block.dataset.avignaaObserved) return;

      block.dataset.avignaaObserved = 'true';
      const observer = new MutationObserver(() => {
        enhanceProductCards();
      });
      observer.observe(block, { childList: true, subtree: true });
    });
  };

  const observeProductGrids = () => {
    observeProductGrid('main-collection-product-grid');
    observeProductGrid('recently-viewed-products-list-2');
    observeRecommendationsBlocks();
  };

  const handleQuickViewClick = (event) => {
    const scope = event.target.closest(CARD_SCOPE_SELECTOR);
    if (!scope) return;

    const trigger = event.target.closest('[data-open-quick-view-popup]');
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    let productHandle = trigger.getAttribute('data-product-handle');

    if (!productHandle) {
      try {
        const jsonEl = trigger.closest('.product-item');
        if (jsonEl?.dataset?.jsonProduct) {
          productHandle = JSON.parse(jsonEl.dataset.jsonProduct).handle;
        }
      } catch (e) {
        /* ignore */
      }
    }

    openCollectionQuickDrawer(productHandle);
  };

  const handleProductDrawerClose = (event) => {
    if (!document.body.classList.contains(PRODUCT_DRAWER_CLASS)) return;

    if (event.target.closest('[data-close-quick-shop-popup]')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeProductQuickDrawer();
      return;
    }

    if (
      document.body.classList.contains('quickshop-popup-show')
      && event.target.classList.contains('background-overlay')
    ) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeProductQuickDrawer();
    }
  };

  const init = () => {
    const hasCollection = !!getCollectionRoot();
    const hasRecentlyViewed = !!document.querySelector('.avignaa-recently-viewed');

    if (!hasCollection && !hasRecentlyViewed) return;

    if (hasCollection) {
      setupFilterDrawer();
      setupToolbarCount();
    }

    enhanceProductCards();
    observeProductGrids();
    document.addEventListener('click', handleQuickViewClick, true);
  };

  document.addEventListener('click', handleProductDrawerClose, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
